import { showError } from './common';
import axios from 'axios';
import { store } from 'store/index';
import { LOGIN } from 'store/actions';
import config from 'config';

export const API = axios.create({
  baseURL: process.env.REACT_APP_SERVER ? process.env.REACT_APP_SERVER : '/'
});

// Attach One API access token to all admin panel requests
API.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem('d1easytrans_auth');
    if (raw) {
      const auth = JSON.parse(raw);
      const apiToken = auth.oneapi_token || auth.token;
      if (apiToken && !config.headers.Authorization) {
        config.headers.Authorization = 'Bearer ' + apiToken;
      }
    }
  } catch (_) {}
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      store.dispatch({ type: LOGIN, payload: null });
      // 401 handled by PrivateRoute
    }

    if (error.response?.data?.message) {
      error.message = error.response.data.message;
    }

    if (!error.config?.disableErrorToast) {
      showError(error);
    }
  }
);
